import React from 'react'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'
import '../../css/loading.css'
/* REDUX */
import { connect } from 'react-redux'
import { loadDelta } from '../../actions/delta'

const loadData = ({ report_id, loadDelta }) => {
	loadDelta(report_id)
}

class Delta extends React.Component {
	
	componentWillMount() {
		loadData(this.props)
	}
	
	componentWillReceiveProps(nextProps) {
		if (nextProps.report_id !== this.props.report_id) {
			loadData(nextProps)
		}
	}
	
	modules = {
	    toolbar: false
    }
	
	render() {
		const { delta } = this.props
		
		if (!delta.story) {
			return (
				<div className="loading-delta">
					<div className="loading-bar-50 mb-3"></div>
					<div className="loading-bar-30 mb-4"></div>
					<div className="loading-bar-100 mb-4"></div>
					<div className="loading-bar-100 mb-4"></div>
					<div className="loading-bar-100"></div>
				</div>
			)
		}
		return (
			<ReactQuill value={ delta.story } readOnly={ true } modules={ this.modules } />
		)
	}
}

const mapStateToProps = (state, ownProps) => {
	const report_id = ownProps.params.report_id
	const {
		deltaById
	} = state
	const deltaWrapper = deltaById[report_id] || {}
	const delta = deltaWrapper.delta || {}
	return {
		report_id,
		delta
	}
}

export default connect(mapStateToProps, { loadDelta })(Delta)


// WEBPACK FOOTER //
// ./src/components/Report/Delta.js